<template>
  <v-col>
    <v-card max-width="auto" class="mx-5" elevation="0">
      <v-app-bar dark color="#0077b6">
        <v-toolbar-title>Asistencias App Móvil</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              icon
              color="white"
              @click="listar()"
              v-bind="attrs"
              v-on="on"
              class="mr-1"
              ><v-icon class="fa fa-sync-alt"></v-icon
            ></v-btn>
          </template>
          <span>Actualizar</span>
        </v-tooltip>
      </v-app-bar>

      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-container>
        <v-row dense>
          <v-col v-for="(item, i) of items" :key="i.idClient" cols="12" md="6">
            <v-card color="#4cc9f0" elevation="5" shaped>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title black--text">
                    Datos del proveedor
                  </v-card-subtitle>
                  <v-card-subtitle class="pl-5 pt-0 pb-0 title white--text"
                    >Nombre: {{ item.nombreProveedor }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 title white--text"
                    >Teléfono: {{ item.telefonoProveedor }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title black--text">
                    Datos del cliente
                  </v-card-subtitle>
                  <v-card-subtitle class="pl-5 pt-0 pb-0 title white--text">
                    Nombre:
                    {{ item.nombreCliente }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text">
                    Teléfono:
                    {{ item.telefonoCliente }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title black--text">
                    Datos del vehículo del cliente
                  </v-card-subtitle>
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Poliza: {{ item.policy }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text"
                    >Marca: {{ item.brandVehicle }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text"
                    >Modelo: {{ item.subBrandVehicle }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text"
                    >Placa: {{ item.plateVehicle }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text"
                    >Color: {{ item.color }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text"
                    >Año: {{ item.ageVehicle }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-1 pb-0 title white--text"
                    >Cometarios: {{ item.commentsClient }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 title white--text"
                    >Dirección: {{ item.origin }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Dirección destino: {{ item.destination }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Coordenadas origen: {{ item.originLat }},{{
                      item.originLng
                    }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Coordenadas destino: {{ item.destinationLat }},{{
                      item.destinationLng
                    }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Tipo de asistencia:
                    {{ item.tipoServicio }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Estatus de la asistencia:
                    {{ item.status }}</v-card-subtitle
                  >
                  <v-card-subtitle class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    >Falla mecánica: {{ item.questionFailed }}</v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    v-if="item.priceAssistance > 0"
                    >Precio de asistencia: ${{
                      item.priceAssistance
                    }}</v-card-subtitle
                  >
                  <v-card-subtitle
                    class="pl-5 pt-0 pb-0 pr-0 title white--text"
                    v-if="item.statusPayment != null"
                    >Estado del pago: {{ item.statusPayment }}</v-card-subtitle
                  >
                  <v-card-actions class="pl-5 pt-0 pr-5">
                    <v-btn
                      outlined
                      rounded
                      small
                      @click="crearAsistencia(item)"
                      v-if="item.sistema != 'asistencia creada'"
                    >
                      CREAR ASISTENCIA
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      outlined
                      rounded
                      small
                      @click="eliminarClientBooking(item)"
                    >
                      QUITAR ASISTENCIA
                    </v-btn>
                  </v-card-actions>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import axios from "axios";
import { dbRefAsistencias, dbRefCliente, dbRefProveedor } from "../main";

export default {
  data() {
    return {
      items: [],
      bitacoras: [],
      fechaHoraActual: "",
      idClient: "",
      nombreClienteDB: "",
      nombreProveedorDB: "",
      telefonoClienteDB: "",
      telefonoProveedorDB: "",
      banderaTiempo: true,
      overlay: false,
    };
  },
  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      me.items = [];
      const listaAsistencias = dbRefAsistencias;

      listaAsistencias.on("child_added", function (snapshop) {
        if (snapshop.val().title == "NOTIFICACION CABINA") {
          //MOSTRAR LAS ASISTENCIA POR MEDIO DE CABINA A APP
          me.obtenerDatosPorCabina(snapshop.val().numeroAsistencia);

          if (snapshop.val().idDriver) {
            me.obtenerDatosProveedor(
              snapshop.val().idDriver,
              snapshop.val().numeroAsistencia
            );
          }

          me.items.forEach(function (element, index) {
            if (element["idClient"] == snapshop.val().numeroAsistencia) {
              me.items[index].idHistoryBooking = "";
              me.items[index].origin = snapshop.val().direccion;
              me.items[index].destination = snapshop.val().direccionDestino;
              me.items[index].km = "";
              me.items[index].price = "";
              me.items[index].payment = "";
              me.items[index].status = snapshop.val().status;
              me.items[index].originLat = "";
              me.items[index].originLng = "";
              me.items[index].destinationLat = "";
              me.items[index].destinationLng = "";
              me.items[index].time = "";
              me.items[index].tipoServicio = snapshop.val().tipoAsistencia;
              me.items[index].sistema = snapshop.val().sistema;
              me.items[index].color = snapshop.val().statusColor;
              me.items[index].ageVehicle = snapshop.val().año;
              me.items[index].brandVehicle = snapshop.val().marca;
              me.items[index].subBrandVehicle = snapshop.val().modelo;
              me.items[index].colorVehicle = snapshop.val().color;
              me.items[index].commentsClient = "";
              me.items[index].plateVehicle = snapshop.val().placa;
              me.items[index].policyVehicle = snapshop.val().poliza;
              me.items[index].questionAccident = "";
              me.items[index].questionFailed = "";
              me.items[index].timeStart = snapshop.val().timeStart;
              me.items[index].timeEnd = snapshop.val().timeEnd;
              me.items[index].timeContact = snapshop.val().timeContact;

              if (!snapshop.val().timeContact && !snapshop.val().timeEnd) {
                me.items[index].color = snapshop.val().statusColor;
              } else if (
                snapshop.val().timeContact &&
                !snapshop.val().timeEnd
              ) {
                me.items[index].color = "#38b000";
              } else {
                me.items[index].color = "#f64740";
              }
            }
          });
        } else {
          //MOSTRAR LAS ASISTENCIA POR MEDIO DE LA APP A APP
          me.obtenerDatosCliente(snapshop.val().idClient);
          if (snapshop.val().idDriver) {
            me.obtenerDatosProveedor(
              snapshop.val().idDriver,
              snapshop.val().idClient
            );
          }

          me.items.forEach(function (element, index) {
            if (element["idClient"] == snapshop.val().idClient) {
              me.items[index].idHistoryBooking =
                snapshop.val().idHistoryBooking;
              me.items[index].origin = snapshop.val().origin;
              me.items[index].destination = snapshop.val().destination;
              me.items[index].priceAssistance = snapshop.val().priceAssistance;
              me.items[index].status = snapshop.val().status;
              me.items[index].originLat = snapshop.val().originLat;
              me.items[index].originLng = snapshop.val().originLng;
              me.items[index].destinationLat = snapshop.val().destinationLat;
              me.items[index].destinationLng = snapshop.val().destinationLng;
              me.items[index].tipoServicio = snapshop.val().tipoServicio;
              me.items[index].sistema = snapshop.val().sistema;
              me.items[index].ageVehicle = snapshop.val().ageVehicle;
              me.items[index].brandVehicle = snapshop.val().brandVehicle;
              me.items[index].subBrandVehicle = snapshop.val().subBrandVehicle;
              me.items[index].policy = snapshop.val().policy;
              me.items[index].color = snapshop.val().color;
              me.items[index].commentsClient = snapshop.val().commentsClient;
              me.items[index].plateVehicle = snapshop.val().plateVehicle;
              me.items[index].questionFailed = snapshop.val().questionFailed;
              me.items[index].statusPayment = snapshop.val().statusPayment;
            }
          });
        }
      });
      listaAsistencias.on("child_removed", function (snapshot) {
        if (snapshot.val().title == "NOTIFICACION CABINA") {
          me.items.forEach(function (element, index) {
            if (element["idClient"] == snapshot.val().numeroAsistencia) {
              me.items.splice(index, 1);
            }
          });
        } else {
          me.items.forEach(function (element, index) {
            if (element["idClient"] == snapshot.val().idClient) {
              me.items.splice(index, 1);
            }
          });
        }
      });
      listaAsistencias.on("child_changed", function (snapshot) {
        if (snapshot.val().title == "NOTIFICACION CABINA") {
          me.items.forEach(function (element, index) {
            if (element["idClient"] == snapshot.val().numeroAsistencia) {
              if (snapshot.val().idDriver) {
                dbRefProveedor
                  .child(snapshot.val().idDriver)
                  .on("value", function (snapshop) {
                    me.items[index].idDriver = snapshop.val().id;
                    me.items[index].nombreProveedor = snapshop.val().name;
                    me.items[index].telefonoProveedor = snapshop.val().phone;
                  });
              }
              if (!snapshop.val().timeContact && !snapshop.val().timeEnd) {
                me.items[index].color = snapshop.val().statusColor;
              } else if (
                snapshop.val().timeContact &&
                !snapshop.val().timeEnd
              ) {
                me.items[index].color = "#38b000";
              } else {
                me.items[index].color = "#f64740";
              }

              me.items[index].idHistoryBooking = "";
              me.items[index].origin = snapshot.val().direccion;
              me.items[index].destination = snapshot.val().direccionDestino;
              me.items[index].km = "";
              me.items[index].price = "";
              me.items[index].payment = "";
              me.items[index].status = snapshot.val().status;
              me.items[index].time = "";
              me.items[index].tipoServicio = snapshot.val().tipoAsistencia;
              me.items[index].sistema = snapshot.val().sistema;
            }
          });
        } else {
          me.items.forEach(function (element, index) {
            if (element["idClient"] == snapshot.val().idClient) {
              if (snapshot.val().idDriver) {
                dbRefProveedor
                  .child(snapshot.val().idDriver)
                  .on("value", function (snapshop) {
                    me.items[index].idDriver = snapshop.val().id;
                    me.items[index].nombreProveedor = snapshop.val().name;
                    me.items[index].telefonoProveedor = snapshop.val().phone;
                  });
              }
              me.items[index].idHistoryBooking =
                snapshot.val().idHistoryBooking;
              me.items[index].origin = snapshot.val().origin;
              me.items[index].destination = snapshot.val().destination;
              me.items[index].statusPayment = snapshot.val().statusPayment;
              me.items[index].status = snapshot.val().status;
              me.items[index].time = snapshot.val().time;
              me.items[index].tipoServicio = snapshot.val().tipoServicio;
              me.items[index].sistema = snapshot.val().sistema;
              me.listar();
            }
          });
        }
      });
    },
    obtenerDatosPorCabina(numeroAsistencia) {
      let me = this;
      dbRefAsistencias
        .child(numeroAsistencia)
        .on("value", function (snapShopCabin) {
          me.items.push({
            idClient: snapShopCabin.val().numeroAsistencia,
            nombreCliente: snapShopCabin.val().title,
            telefonoCliente: "",
          });
        });
    },
    obtenerDatosCliente(idClient) {
      let me = this;
      dbRefCliente.child(idClient).on("value", function (snapshopClient) {
        me.items.push({
          idClient: snapshopClient.val().id,
          nombreCliente: snapshopClient.val().name,
          telefonoCliente: snapshopClient.val().phone,
        });
      });
    },
    obtenerDatosProveedor(idDriver, idClient) {
      let me = this;
      dbRefProveedor.child(idDriver).on("value", function (snapshopDriver) {
        me.items.forEach(function (element, index) {
          if (element["idClient"] == idClient) {
            me.items[index].idDriver = snapshopDriver.val().id;
            me.items[index].nombreProveedor = snapshopDriver.val().name;
            me.items[index].telefonoProveedor = snapshopDriver.val().phone;
          }
        });
      });
    },
    crearAsistencia(item) {
      var today = new Date();
      this.fechaHoraActual =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      let fechaAsignacion =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      //HACER LA PETICION PARA CREAR LA ASISTENCIA EN SQLServer
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlay = true;
      me.idClient = item.idClient;
      axios
        .post(
          "api/Cabinas/Crear",
          {
            idBase: "",
            idUsuario: me.$store.state.usuario.idUsuario,
            idProveedor: null,
            cartera: "ASSA COMPAÑIA DE SEGUROS",
            fechaHoraActual: me.fechaHoraActual,
            fechaHoraOcurrencia: "",
            numeroTelefono: item.telefonoCliente,
            placa: item.plateVehicle,
            poliza: item.policy,
            marca: item.brandVehicle,
            modelo: item.subBrandVehicle,
            año: item.ageVehicle,
            uso: "",
            color: item.color,
            nombreConductor: item.nombreCliente,
            titularPoliza: item.nombreCliente,
            pais: "",
            depaSiniestro: "",
            muniSiniestro: "",
            comDireccionSiniestro: item.origin,
            causa: "",
            tipoServicio: item.tipoServicio,
            proveedor: item.nombreProveedor,
            telefonoProveedor: "",
            atiende: "",
            fechaHoraAsignacion: fechaAsignacion,
            depaOrigen: "",
            muniOrigen: "",
            comDireccionOrigen: item.origin,
            depaDestino: "",
            muniDestino: "",
            comDireccionDestino: item.destination,
            fechaHoraContacto: "",
            costoServicio: 0,
            fechaHoraCierreAsistencia: "",
            placaContraparte: "",
            partePolicial: false,
            obsAdicionales:
              "Coordenadas: " +
              item.originLat +
              "," +
              item.originLng +
              " \n Comentarios del cliente: " +
              item.commentsClient +
              "\n Preguntas: " +
              item.questionAccident +
              ", " +
              item.questionFailed,
            tipoAsistencia: item.tipoServicio,
            numeroSiniestroQualitas: "",
            numeroSpoolerQualitas: "",
            seMovioDelLugar: false,
            zonaPeligrosa: false,
            reporteTardio: false,
            operador: me.$store.state.usuario.nombre,
            estatusAsistencia: "EN PROCESO",
            roboRecuperado: false,
            localForaneo: "",
            cantRecupero: "",
            termino: "",
            estadoEbriedad: false,
            bitacoras: me.bitacoras,
          },
          configuracion
        )
        .then(function (response) {
          const listaAsistencias = dbRefAsistencias;
          listaAsistencias.child(me.idClient).update({
            sistema: "asistencia creada",
          });
          me.overlay = false;
        })
        .catch(function (error) {
          console.log(error);
          me.overlay = false;
        });
      me.obtenerDatosBitacora(item);
      this.bitacoras = [];
      //me.enviarCorreo();
    },
    eliminarClientBooking(item) {
      dbRefAsistencias.child(item.idClient).on("value", function (snapshop) {
        dbRefAsistencias
          .child(item.idClient)
          .remove()
          .then(function (response) {
            console.log("eliminado con exito");
          });
      });
    },
    obtenerDatosBitacora(item) {
      let me = this;
      me.bitacoras.push({
        idUsuario: me.$store.state.usuario.idUsuario,
        fechaHoraActual: me.fechaHoraActual,
        operador: "AppMovil",
        comDireccionSiniestro: item.origin,
        tipoServicio: item.tipoServicio,
        proveedor: item.nombreProveedor,
        atiende: "",
        fechaHoraAsignacion: "",
        seguimiento: "",
        fechaHoraContacto: "",
        fechaHoraCierreAsistencia: "",
        obsAdicionales: "",
      });
    },
    enviarCorreo() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios.put(
        "api/Cabinas/sendEmail/",
        {
          cartera: "ASSA COMPAÑIA DE SEGUROS",
          titularPolizaBase: me.nombreCliente,
          nombreConductor: me.nombreCliente,
          placa: me.plateVehicle,
          polizaBase: me.policyVehicle,
          marcaBase: me.brandVehicle,
          modeloBase: me.subBrandVehicle,
          color: "",
          añoBase: me.ageVehicle,
          tipoAsistencia: me.tipoServicio,
          comDireccionSiniestro: me.origin,
        },
        configuracion
      );
    },
  },
};
</script>
